module.exports = __webpack_public_path__ + "img/sample_ic_both.bec79443.jpg";